import PropTypes from 'prop-types';
import React from 'react';

import Strong from 'components/Strong';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const NavJumpLink = ({ href }) => (
  <a className="NavJumpLink" href={href}>
    <Strong>{I18n.localize('nav.jumpToContent')}</Strong>
    <style jsx>
      {`
        .NavJumpLink {
          padding: 0;
          border: 0;
          border-radius: 2px;
          color: ${Theme.get('colors-black')};
          background-color: ${Theme.get('colors-white')};
          text-transform: uppercase;
          text-decoration: none;

          // Visually hidden, but accessible to screen readers
          position: absolute;
          overflow: hidden;
          clip: rect(0 0 0 0);
          height: 1px;
          width: 1px;
        }

        .NavJumpLink:focus {
          position: static;
          overflow: visible
          clip: auto;
          height: auto;
          width: auto;
          padding: 2px 6px;
          border: 2px solid ${Theme.get('colors-black')};
        }
      `}
    </style>
  </a>
);

NavJumpLink.propTypes = {
  href: PropTypes.string.isRequired,
};

export default NavJumpLink;
